export const NO_RESULTS_FOUND_MSG = 'Sorry, we could not find any results';
